import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=486d09dc&scoped=true&lang=pug&"
import script from "./Points.vue?vue&type=script&lang=js&"
export * from "./Points.vue?vue&type=script&lang=js&"
import style0 from "./Points.vue?vue&type=style&index=0&id=486d09dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486d09dc",
  null
  
)

export default component.exports